<app-bread-crumbs [navigationRoute]="currentRoute" [currentPageString]="currentPageString"
  [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage"
  [clickHandler]="returnToPreviousPage">
</app-bread-crumbs>

<div class="page-container">
  <app-layout class="container--form">
    <div *ngIf="isLoadingData">
      <mat-spinner class="mydocs-spinner"></mat-spinner>
      <div class="mydocs-spinner-text paragraph-medium-regular">
        <p>Retrieving data...</p>
      </div>
    </div>
    <div *ngIf="!isLoadingData" class="table-wrapper">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z3 content-table">
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">{{ element.Action }}</td>
        </ng-container>

        <ng-container matColumnDef="workflow">
          <th mat-header-cell *matHeaderCellDef>Workflow</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Workflow }}
          </td>
        </ng-container>

        <ng-container matColumnDef="personnel">
          <th mat-header-cell *matHeaderCellDef>Personnel</th>
          <td mat-cell *matCellDef="let element">
            <ng-template [ngIf]="element.IsCovering">
              {{ element.CoveringName }}
              <app-covering-officer-chip [originalPersonnelName]="element.PersonnelName"></app-covering-officer-chip>
            </ng-template>
            <ng-template [ngIf]="!element.IsCovering">{{ element.PersonnelName}}</ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="appointment">
          <th mat-header-cell *matHeaderCellDef>Appointment</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Appointment }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Date | date : "dd/MM/yy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef aria-label="row actions">
            &nbsp;
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button aria-label="expand row" (click)="
              expandedElement = expandedElement === element ? null : element;
              $event.stopPropagation()
            ">
              <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
            <div class="expansion-panel" [@detailExpand]="
              element == expandedElement ? 'expanded' : 'collapsed'
            ">
              <div class="content">
                <div class="title">Comments:</div>
                <div class="text">{{ element.Comment ? element.Comment : '-' }}</div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand" class="element-row"
          [class.expanded-row]="expandedElement === element"
          (click)="expandedElement = expandedElement === element ? null : element"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
        >
      </table>
    </div>
    <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="currentPage" (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
  </app-layout>
</div>